// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2145":"7c697f1e","3274":"cfe3c458","5180":"d3f2e0bd","5783":"7c697f1e","6085":"4a8d2b85","7371":"3273f8ac","9029":"3273f8ac"}[chunkId] + ".chunk.css";
};